// Profile Settings API endpoints
export const PROFILE_ENDPOINTS = {
  CURRENT_USER: '/users/current-user/',
  UPDATE_PHOTO: '/users/current-user/update_photo/',
  NOTIFICATION_PREFERENCES: '/users/notification-preferences/',
} as const;

// Profile Settings storage keys
export const PROFILE_STORAGE_KEYS = {
  USER_PHOTO: 'user_photo',
  NOTIFICATION_SETTINGS: 'notification_settings',
} as const;
